import { action, type ActionMessage } from 'satcheljs';

export const initializeTodayWebDocumentHost: () => ActionMessage = action(
    'initializeTodayWebDocumentHost'
);
